(function() {
  angular.module('admin')
    .controller('userEditController', ['$uibModalInstance', 'user', '$uibModal', 'adminUsers', 'Dso', '$scope',
    'secSecurityService','dsoProviderService', '$rootScope', 'uiGridConstants', '$filter', 'gridServices', 'DsoUsers','TaxLocationUtility','$q',
    function($uibModalInstance, user, $uibModal, Users, Dso, $scope,
      secSecurityService, dsoProviderService, $rootScope, uiGridConstants, $filter, gridServices, DsoUsers, TaxLocationUtility, $q) {
      var vm = this;
      vm.editUserModalInstance = $uibModalInstance;
      vm.user = _.clone(user);
      vm.running = false;
      vm.initialStatus = user.status;
      vm.providerLocations = [];
      vm.gridOptions = vm.userSearchGridOptions = {
        enableSorting: true,
        enableColumnResizing: true,
        enableRowHeaderSelection: false,
        exporterMenuPdf: false,
        enableGridMenu: true,
        columnDefs: [

          { field: 'eventData.eventName', displayName: 'Event', width: 250},
          { field: 'getTimestamp()' , displayName: 'Timestamp', width: 130,
            sortingAlgorithm: gridServices.dateSort(vm, (row) => row.auditData.created),
            sort: {
              direction: uiGridConstants.DESC,
              priority: 0
            }
          },
          { field: 'getLogin()', displayName: 'Login', width: 75 },
          { field: 'eventData.prettyEventData', displayName: 'Event Data'}
        ],
        onRegisterApi: function(api) {
          vm.gridApi = api;
        }
      };

      var userType = vm.user.userType;
      if(userType && userType.toLowerCase() == 'provider'){
        DsoUsers.getProviderLocations({userId: vm.user.userId}).$promise
        .then((data) => {
          TaxLocationUtility.filterLocations(data).then(function(result){
            vm.providerLocations = result;
          });
        });
      }

      function getLogin() {
        if (this.actorLogin.indexOf('fdl.dpp.') !== 0) {
          return this.actorLogin;
        }
      }
      let tzOffset = new Date().getTimezoneOffset() * 60 * 1000;
      function getTimestamp() {
        let d = new Date(this.auditData.created).getTime();
        return $filter('date')(d - tzOffset, 'M/d/yy h:mm a');
      }
      vm.gridRunning = true;
      vm.auditEventsPromise = Users.getAuditEvents({userId: user.userId}).$promise;
      $scope.$on('authenticationChanged', () => {
          $uibModalInstance.dismiss();
      });

      $scope.formatUserType = function(string) {
        if(string){
          return string.charAt(0).toUpperCase() + string.slice(1);
        }
        else {
          return '';
        }
      };

      vm.resetPassword = function() {
        vm.running = true;
        Users.resetPassword({userId: user.userId}, function() {
          ajaxResponse();
          $scope.dnConfirmationMessage.$show("Password reset link has been sent.");
        }, ajaxResponse);
      };
      vm.resendEmailVerification = function() {
        vm.running = true;
        Users.resendEmailVerification({userId: user.userId}, function() {
          ajaxResponse();
          $scope.dnConfirmationMessage.$show("Email verification link has been sent.");
        }, ajaxResponse);
      };
      vm.close = function() {
        $uibModalInstance.dismiss();
      };
      vm.submit = function() {
        $uibModalInstance.close({active: vm.user.status === 'active'});
      };
      vm.userView = function() {
        secSecurityService.switchUser(user.userId).then((result) => {
          if (result.authentication) {
            $rootScope.$broadcast('authenticationChanged', {loggedIn: true});
          }  else {
            $scope.dnConfirmationMessage.$show(
              secSecurityService.getAuthenticationErrorMessage(result.exception, true), 'warning');
          }
        });
      };
      vm.delete = function() {
        $uibModal.open({
          controller:['$uibModalInstance', 'user', '$scope', function($uibModalInstance, user, $scope) {
            var self = this;
            self.user = user;
            self.delete = function() {
              $uibModalInstance.close(true);
            };
            self.close = function() {
              $uibModalInstance.dismiss();
            };
            $scope.$on('authenticationChanged', () => {
              $uibModalInstance.dismiss();
            });
          }],
          templateUrl: '/js/admin/confirmDelete.html' + appVersion,
          size: 'sm',
          animation: false,
          controllerAs: 'confirmation',
          resolve: {
            user: () => vm.user
          }
        }).result.then(function(val) {
          if (val) {
            $uibModalInstance.close({delete: true});
          }
        }, angular.noop);
      };

      function ajaxResponse() {
        vm.running = false;
      }
      

    }]);
})();
